import axios from 'axios';

// Create axios instance
const api = axios.create({
    baseURL: import.meta.env.VITE_API_URL || '/api',
    withCredentials: true, // Required for sending cookies (session)
    headers: {
        'Content-Type': 'application/json',
    },
});

// Request interceptor to inject mock auth header
api.interceptors.request.use((config) => {
    const user = JSON.parse(localStorage.getItem('user') || 'null');
    if (user && user.email) {
        config.headers['x-mock-user-email'] = user.email;
    }
    return config;
});

// Response interceptor for error handling
api.interceptors.response.use(
    (response) => response,
    (error) => {
        // Handle session expiry or auth errors here
        if (error.response?.status === 401) {
            // e.g., redirect to login
            console.warn('Unauthorized access');
        }
        return Promise.reject(error);
    }
);

export default api;
